import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { User } from 'anchor-shared/lib/model/entity/user';
import { UserDAO } from '../../../core/services/dao/userDAO';

@Component({
  selector: 'app-sign-up-profile-photo',
  templateUrl: './sign-up-profile-photo.component.html',
  styleUrls: ['./sign-up-profile-photo.component.scss'],
})
export class SignUpProfilePhotoComponent implements OnInit, OnDestroy {
  model: User;

  constructor(private userDAO: UserDAO, private router: Router) {}

  ngOnInit() {
    this.model = this.userDAO.getCurrentUser();
    console.log(this.model);
  }

  ngOnDestroy(): void {}

  save() {
    this.router.navigate(['sign-up/confirm-phone']);
  }
}
